import type { FaireProductEntity } from "../../entity_types/product";

export const p_fv6edk44re: FaireProductEntity = {
  token: "p_fv6edk44re",
  type: "product",
  name: "Lemon Lime",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/308c6e086b3a91bcb5f0baeeda6c9609655437c921b8387d38baf8bd669c7ac1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7f54a8e58d3f81d658ce7f6863504a74da441ee1afb89ed01f2f0b0159936c0.png",
    "https://cdn.faire.com/fastly/ec3c8d375c15d367ba328f1c3bef71272fb7a419a318fa507aacd7a88df207e8.png",
    "https://cdn.faire.com/fastly/fcbd59eb213b119abe556ba12d5400ba51979741d111c585495540170554159d.png",
  ],
  priceDollars: 28.99,
  description:
    "Like a sweet key lime pie with a fresh squeeze of lemon, this thirst-quenching soda is so refreshing it’ll make you say, “ahhhhhhhhhh.”\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:11.235Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
